import { render } from "./edit.vue?vue&type=template&id=5bb3b279&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=5bb3b279&scoped=true&lang=scss"
import "./edit.vue?vue&type=style&index=1&id=5bb3b279&lang=scss"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb3b279"]])

export default __exports__